// Navigator.tsx

import React, { useState } from 'react';

import { useNavigator } from 'src/hooks/useNavigator';
import { useAppSelector } from 'src/store/reducers';

import type { NavigatorSection } from '../../util/getSections';

import Icon from '@helsenorge/designsystem-react/components/Icon';
import ChevronDown from '@helsenorge/designsystem-react/components/Icons/ChevronDown';
import ChevronUp from '@helsenorge/designsystem-react/components/Icons/ChevronUp';

import { NavigatorMenu } from './NavigatorMenu';
import { useSectionScroll } from './useSectionScroll';

type Props = {
  lastActivity: number;
};

const Navigator = ({ lastActivity }: Props): React.JSX.Element | null => {
  const { sections, isNavigatorInitiated } = useNavigator(lastActivity);
  const { isMicroweb, showNavigator } = useAppSelector(state => state.microweb);

  const [selectedSection, setSelectedSection] = useState<NavigatorSection | null>(sections[0] || null);
  const [isNavigatorMenuExpanded, setIsNavigatorMenuExpanded] = useState<boolean>(false);

  const hideNavigator = sections.length === 0 || !isNavigatorInitiated || (isMicroweb && !showNavigator);

  const toggleNavigatorExpand = (): void => {
    setIsNavigatorMenuExpanded(!isNavigatorMenuExpanded);
  };

  useSectionScroll({ sections, setSelectedSection });

  if (hideNavigator) {
    return null;
  }
  return (
    <div className="page_refero__navigator container">
      <button
        data-testid="navigator-button"
        id="navigator-button"
        className="page_refero__navigatorheader"
        onClick={toggleNavigatorExpand}
        aria-expanded={isNavigatorMenuExpanded}
      >
        <div className="page_refero__navigatorheader-text">{selectedSection?.name}</div>
        {isNavigatorMenuExpanded ? <Icon svgIcon={ChevronUp} /> : <Icon svgIcon={ChevronDown} />}
      </button>
      {isNavigatorMenuExpanded && (
        <NavigatorMenu
          sections={sections}
          setSelectedSection={setSelectedSection}
          toggleNavigatorExpand={toggleNavigatorExpand}
          selectedSection={selectedSection}
        />
      )}
    </div>
  );
};

export default Navigator;
